<template>
  <section>
    <el-row  style="min-width:1100px;padding:15px;margin-bottom:30px">
      <el-col :span="3">
        <el-button type="text" >广告投放日志</el-button>
      </el-col>
      <el-col :span="5" :offset="16">
   
      </el-col>
    </el-row>
		
		<el-row>
			 <el-table :data="plog">
			 	<el-table-column prop="name" label="名称" width="200"></el-table-column>
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
      
      <div class="pageRow">
	    <el-pagination
	      class="pagination"
	      @size-change="SizeChange"
	      @current-change="CurrentChange"
	      :current-page.sync="pdata.page"
	      :page-sizes="[20, 40, 60, 80]"
	      :page-size="pdata.perpage"
	      background
	      layout="sizes, prev, pager, next, jumper"
	      :total="pdata.perpage*maxPage"
	    ></el-pagination>
    </div>
		</el-row>
		

  </section>
</template>
<script>
import { logList, } from "../../api/api";
export default {
  data() {
    return {
      plog: [],
     	pdata: {
        page: 1,
        perpage: 20,
        status: "",
        kw: "",
        sort_field: "",
        sort_by: ""
      },
      maxPage: 1,
    };
  },
  methods: {
    openDealy(id) {
  	 	var p = '&type=plan&';
  	 	 for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      logList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data.list;
          this.maxPage = res.data.max_page;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    
    log(t) {
      this.$alert(t, "更新日志");
    },
		SizeChange(v) {
      this.pdata.perpage = v;
      this.openDealy();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.openDealy();
    },


  },
  mounted() {
    this.openDealy('');
  }
};
</script>
<style>
.el-timeline{
  width: 500px;
}
</style>




// WEBPACK FOOTER //
// sdkAdLogo.vue?5401630f